import { render, staticRenderFns } from "./WsDataTableWithTitle001.vue?vue&type=template&id=c849bd48"
import script from "./WsDataTableWithTitle001.vue?vue&type=script&lang=js"
export * from "./WsDataTableWithTitle001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports